import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserCog } from 'lucide-react';
import { updateUsername, USERNAME_MAX_LENGTH } from '../../lib/api/updateUsername';
import { useUserStore } from '../../lib/userStore';
import toast from 'react-hot-toast';

export function UpdateUsername() {
  const navigate = useNavigate();
  const [newUsername, setNewUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const currentUsername = useUserStore((state) => state.username);
  const userId = useUserStore((state) => state.user_id);
  const setUsername = useUserStore((state) => state.setUsername);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!userId) return;

    setLoading(true);
    const result = await updateUsername(userId, newUsername);
    setLoading(false);

    if (!result.success || !result.username) {
      toast.error(result.error || "Erreur lors de la mise à jour du nom d'utilisateur");
      return;
    }

    setUsername(result.username);
    toast.success('Nom d\'utilisateur mis à jour avec succès');
    navigate('/my-office');
  };

  return (
    <div className="card shadow-lg border-0">
      <div className="card-body p-5">
        <div className="text-center mb-4">
          <UserCog className="h-12 w-12 text-primary mb-2" />
          <h2 className="card-title text-center mb-4">Modifier le nom d'utilisateur</h2>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="form-label">Nom d'utilisateur actuel</label>
            <input
              type="text"
              className="form-control"
              value={currentUsername || ''}
              disabled
            />
          </div>

          <div className="mb-4">
            <label htmlFor="newUsername" className="form-label">
              Nouveau nom d'utilisateur
            </label>
            <input
              type="text"
              className="form-control"
              id="newUsername"
              value={newUsername}
              onChange={(e) => setNewUsername(e.target.value)}
              placeholder="Entrez votre nouveau nom d'utilisateur"
              required
              pattern="[a-zA-Z0-9\s]+"
              maxLength={USERNAME_MAX_LENGTH}
              title="Lettres, chiffres et espaces uniquement"
            />
            <small className="text-muted">
              Le nom d'utilisateur ne doit contenir que des lettres, des chiffres et des espaces
            </small>
          </div>

          <div className="d-grid gap-2">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading || !newUsername.trim() || newUsername === currentUsername}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Mise à jour...
                </>
              ) : (
                'Mettre à jour'
              )}
            </button>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => navigate('/my-office')}
            >
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}